import { Alert } from "antd";
import { FC } from "react";

interface RemarkProps {
  text: string;
}

interface RemarksProps {
  texts: (string | null)[];
}

export const Remark: FC<RemarkProps> = ({ text }) => {
  return (
    <Alert
      style={{ marginTop: 10, display: "block" }}
      message={text}
      type="info"
    />
  );
};

export const Remarks: FC<RemarksProps> = ({ texts }) => {
  const nonNullTexts = texts.filter((text) => text !== null);

  if (nonNullTexts.length === 0) return null;

  return (
    <>
      {nonNullTexts.map((text, i) => (
        <Remark key={i} text={text} />
      ))}
    </>
  );
};
